import { render, staticRenderFns } from "./ListCourse.vue?vue&type=template&id=07a8107b&"
import script from "./ListCourse.vue?vue&type=script&lang=ts&"
export * from "./ListCourse.vue?vue&type=script&lang=ts&"
import style0 from "./ListCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports